// extracted by mini-css-extract-plugin
export var active = "_cp-2";
export var recordingDot = "_cp-1";
export var recordingIndicator = "_cp-0";